// extracted by mini-css-extract-plugin
export default {"r_l":"_83177cc99d _98e357f7aa","t":"_943d056ec1"};